import $api from "@/frontend/shared/api/axios";
import { TProductsData } from "./types/types";
import { MetascraperProductsSchema } from "@/libs/models/companies";

export async function getPortfolioCompanyProducts({ id }: { id: number }) {
  const response = await $api.get<{ data: TProductsData }>(`/portfolio-companies/${id}/products`);
  const parsed = MetascraperProductsSchema.parse(response.data.data);
  return parsed;
}
